var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcwLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 1750 1750",
    width: 1750,
    height: 1750,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1708.79 871.41C1708.79 409.58 1334.4 35.19 872.57 35.19C410.74 35.19 36.35 409.58 36.35 871.41C36.35 1333.25 410.74 1707.64 872.57 1707.64C928.31 1707.64 1207.05 1707.64 1708.79 1707.64L1708.79 1707.64C1708.79 1205.9 1708.79 927.16 1708.79 871.41Z",
    id: "h55rMQhB1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.75 172.31L904.53 291.86L764.85 345.8L764.54 216.82L764.54 216.82L904.75 172.31Z",
    id: "b7dEcVCHQz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.62 957.42C723.19 976.89 836.19 913.05 862.01 849.2C912.38 899.59 979.04 968.8 1120.98 956.91C1241.23 946.84 1322.79 867.32 1355.16 800.15C1342.02 792.66 1236.95 732.78 1223.81 725.3C1191.73 791.57 1108.39 832.76 1030.06 794.7C951.74 756.65 929.38 672.57 964.88 599.5C1000.38 526.43 1088.91 497.65 1158.62 535.85C1199.52 558.27 1221.72 587.86 1230.04 619.96C1243.88 613.73 1354.6 563.92 1368.44 557.7C1330.95 481.48 1287.4 414.33 1167.12 379.21C1082.35 354.46 959.99 378.29 905.96 438.4C905.97 430.88 906.04 393.31 906.17 325.66L765.99 382.76C766.15 568.02 766.24 670.94 766.26 691.53C761.61 750.85 713.96 823.92 613.76 813.61C545.52 806.58 497.71 760.25 475.67 711.75C470.12 714.38 357.46 784.37 356.85 784.53C356.85 784.53 356.85 784.53 356.85 784.53C404.4 883.43 482.98 941.07 592.62 957.42Z",
    id: "cuFIPgMbC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.32 1502.37C1227.63 1508.21 1350.79 1383.23 1350.86 1272.83C1350.87 1249.17 1350.95 1130.87 1351.08 917.93L1194.62 989.7C1194.61 1160.01 1194.61 1254.63 1194.61 1273.56C1196.96 1331.57 1145.57 1371.83 1077.44 1371.04C1009.3 1370.25 950.35 1346.53 950.64 1268.86C950.64 1246.72 950.63 1136.04 950.62 936.8L794.17 1008.57C794.16 1169.82 794.15 1259.4 794.15 1277.32C796.51 1334.37 723.14 1379.33 655.01 1378.54C586.88 1377.75 527.92 1354.03 528.45 1276.36C528.46 1255.53 528.54 1151.38 528.67 963.92L372.21 1035.69C372.2 1193.11 372.2 1280.56 372.19 1298.05C375.12 1367.31 422.4 1470.92 585.34 1497.73C748.28 1524.54 858.32 1442.36 869.24 1423.6C869.24 1423.6 869.24 1423.6 869.24 1423.6C909.08 1472.22 978.78 1498.47 1078.32 1502.37Z",
    id: "e5Kzu3ZQh"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h55rMQhB1F",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h55rMQhB1F",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#8bc646",
    strokeWidth: 56.69,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7dEcVCHQz",
    opacity: 1,
    fill: "#3474bb",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7dEcVCHQz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cuFIPgMbC",
    opacity: 1,
    fill: "#3474bb",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cuFIPgMbC",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e5Kzu3ZQh",
    opacity: 1,
    fill: "#8bc646",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e5Kzu3ZQh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcwLogoWhite);
export default __webpack_public_path__ + "static/media/JCWLogo-white.2488fa48533f4ac61d205223c0b9e6b3.svg";
export { ForwardRef as ReactComponent };